import { jsx as _jsx } from "react/jsx-runtime";
import { useRouter } from "@faire/retailer-visitor-shared/app/_lib/routing/useRouter";
import React, { createContext, useContext } from "react";
var NextRouterContext = /*#__PURE__*/ createContext({
    prefetch: function() {},
    refresh: function() {}
});
export var NextRouterContextProvider = function(param) {
    var children = param.children;
    var router = useRouter();
    return /*#__PURE__*/ _jsx(NextRouterContext.Provider, {
        value: router,
        children: children
    });
};
/**
 * This is a temporary hook that allows us to access the NextJS router.
 * In the legacy app, this will return `undefined`.
 *
 * Once we ship NextJS to 100%, we can remove this in favour of
 * `useRouter` from `next/router`.
 */ export var useNextRouterContext = function() {
    return useContext(NextRouterContext);
};
